import { Relation } from '../builder';
import { ParseRes, ParseCtx } from './eraql-ast/ast';
import { parseRel } from './parse';
import _ from 'lodash';
import { RelFR } from '../ast/ast';
import { relToEraQL } from './eraql';

type RawEraqlRelationCompiler = (
  rawCode: readonly string[],
  keys: readonly (RelFR | Relation)[],
  ctx: ParseCtx
) => ParseRes<Relation>;

export type EraqlRelationCompiler = (
  rawCode: readonly string[],
  ...keys: readonly (RelFR | Relation)[]
) => Relation;

const rawQlRelationCompiler: RawEraqlRelationCompiler = (
  rawCode,
  keys,
  opts
) => {
  const parts: string[] = [];

  for (const [code = '', interpolated] of _.zip(rawCode, keys)) {
    parts.push(code);

    if (interpolated !== undefined) {
      const rel = Relation.wrap(interpolated);
      // parens are required to not break operator precedence
      parts.push(`(${relToEraQL(rel.ir())})`);
    }
  }

  const eraCode = parts.join('');
  return parseRel(eraCode, opts);
};

export const makeEraqlRelationCompiler = (
  ctx: ParseCtx,
  opts: {
    jsStackPointer?: Function;
  }
): EraqlRelationCompiler => {
  const inner: EraqlRelationCompiler = (rawCode, ...keys) => {
    const { jsStackPointer = inner } = opts;
    const res = rawQlRelationCompiler(rawCode, keys, ctx);

    if (res.isErr()) {
      const [e, _meta] = res.error;
      if (e && e[0].t === 'type-check-error') {
        throw e[0].trace.toError({ jsStackPointer });
      } else {
        const error = new Error(`${e![0].t}`);

        if ((Error as any).captureStackTrace && jsStackPointer !== undefined) {
          (Error as any).captureStackTrace(error, jsStackPointer);
        }

        throw error;
      }
    }

    return res.value;
  };

  return inner;
};
